import { getDateFormatted, getDateNow } from "@/utils/dates";

export const ALLOWED_MIME_TYPES_IMAGE = ["image/jpeg", "image/png"];
export const ALLOWED_MIME_TYPES_VIDEO = ["video/mp4"];

export const ALLOWED_MIME_TYPES_DOCUMENT = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const ALLOWED_MIME_TYPES_COMPRESSED = [
  "application/zip",
  "application/gzip",
  "application/tar",
  "application/x-tar",
  "application/x-7z-compressed",
];

export const ALLOWED_MIME_TYPES_ALL = [
  ...ALLOWED_MIME_TYPES_IMAGE,
  ...ALLOWED_MIME_TYPES_VIDEO,
  ...ALLOWED_MIME_TYPES_DOCUMENT,
  ...ALLOWED_MIME_TYPES_COMPRESSED,
];

export const fileExtensionByMime: Record<string, string> = {
  "image/jpeg": ".jpeg",
  "image/png": ".png",
  "video/mp4": ".mp4",
  "application/pdf": ".pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
  "application/zip": ".zip",
  "application/gzip": ".tar.gz",
  "application/tar": ".tar",
  "application/x-tar": ".tar",
  "application/x-7z-compressed": ".7z",
};

export function isVideoFile(fileName: string) {
  const x = ALLOWED_MIME_TYPES_VIDEO.some((v) => fileName.includes(fileExtensionByMime[v]));
  return x;
}

export function isImageFile(fileName: string) {
  const x = ALLOWED_MIME_TYPES_IMAGE.some((v) => fileName.includes(fileExtensionByMime[v]));
  return x;
}

export function isDocumentFile(fileName: string) {
  const x = ALLOWED_MIME_TYPES_DOCUMENT.some((v) => fileName.includes(fileExtensionByMime[v]));
  return x;
}

export function isCompressedFile(fileName: string) {
  const x = ALLOWED_MIME_TYPES_COMPRESSED.some((v) => fileName.includes(fileExtensionByMime[v]));
  return x;
}

export const createCsvTitle = (entity?: string) => {
  const dateString = getDateFormatted(getDateNow(), "date-short-file");
  return `csv-export-${entity ?? ""}-${dateString}`;
};

export const saveCsvFile = (data: string, filename: string) => {
  const file = new File([data], filename, { type: "text/csv" });
  const exportUrl = window.URL.createObjectURL(file);
  window.location.assign(exportUrl);
  setTimeout(() => {
    window.URL.revokeObjectURL(exportUrl);
  }, 0);
};
